import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import {MenuListing,  MenuAddEdit } from './pages';

export const MenuRoutes = ({ match }) => (
    <Fragment>
        { <Route exact path = {`${match.path}`} component={MenuListing} /> }
        <Route exact path = {`${match.path}/AddEdit`} component={MenuAddEdit} />
    </Fragment>
)